import { getUrlSearchParams } from './getUrlSearchParams';

const urlParams = getUrlSearchParams();
const productID = urlParams.get('product');

export const localStorageItemName = `configuratorHash${productID}`;
